import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { SealMark } from '@/components/ui/SealMark';

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <header
        className="no-print fixed inset-x-0 top-0 z-[100] flex items-center justify-between
                   px-6 py-4 md:px-10 md:py-[18px]
                   bg-ink-950/85 backdrop-blur-md
                   border-b border-gold-400/10
                   shadow-[0_4px_24px_rgba(0,0,0,0.35)]"
      >
        <Link to="/" className="flex items-center gap-3 font-display font-semibold
                                uppercase tracking-[0.18em] text-[13px] md:text-[15px] text-gold-300">
          <SealMark />
          <span>Ars Magica</span>
        </Link>
        <nav className="hidden md:flex items-center gap-9 text-[13px] font-display
                        uppercase tracking-[0.15em] text-parchment-100">
          <NavLinkItem to="/" end>Home</NavLinkItem>
          <NavLinkItem to="/about">About</NavLinkItem>
          <a
            className="nav-link relative py-1.5 opacity-70 transition-colors hover:opacity-100 hover:text-gold-300"
            href="https://publish.obsidian.md/ars-magica-definitive-manuscript/Homepage"
            target="_blank"
            rel="noreferrer noopener"
          >
            Manuscript
          </a>
        </nav>
      </header>

      <main className="flex-1">{children}</main>

      <footer
        className="no-print border-t border-gold-400/10 px-6 py-14 md:py-[60px_24px_80px]
                   text-center text-[13px] tracking-[0.08em] text-parchment-100/45"
      >
        <div
          className="mx-auto mb-4 grid place-items-center rounded-full border border-gold-500
                     font-display font-bold tracking-[0.05em] text-gold-400"
          style={{ width: 44, height: 44, fontSize: 13 }}
          aria-hidden="true"
        >
          Æ
        </div>
        <div className="mx-auto max-w-2xl leading-relaxed">
          A fan-made character creator for <em>Ars Magica — Definitive Edition</em>.
          Ars Magica and all associated marks are © Atlas Games. Mechanics only under the
          ArM5 Open License — no verbatim manuscript prose, links to the source.
          <br />
          Donation-supported · Open License compliant · Built with ink &amp; code.
        </div>
      </footer>
    </div>
  );
}

function NavLinkItem({
  to,
  end,
  children,
}: {
  to: string;
  end?: boolean;
  children: ReactNode;
}) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `nav-link relative py-1.5 transition-colors ${
          isActive
            ? 'text-gold-300 opacity-100'
            : 'opacity-70 hover:opacity-100 hover:text-gold-300'
        }`
      }
    >
      {children}
    </NavLink>
  );
}
